<template>
  <SmallSquare content="可对经销商或品牌直营门店的报销单进行审批" :padding='true' />
  <a-card :bordered="false">
    <a-button type="primary" v-has:reimburseAdd="()=> {$router.push('/assets/reimburse/add')}">
      <PlusOutlined />新建手动报销单
    </a-button>
    <a-tabs class='m-t-10' v-model:activeKey="search.bill_status" @change='tabChange'>
      <a-tab-pane key="" tab="全部"></a-tab-pane>
      <a-tab-pane :key="0" tab="未审批"></a-tab-pane>
      <a-tab-pane :key="1" tab="报销成功"></a-tab-pane>
      <a-tab-pane :key="2" tab="取消报销"></a-tab-pane>
      <a-tab-pane :key="3" tab="审批超时"></a-tab-pane>
    </a-tabs>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="报销对象" name='bill_target_name'>
        <a-input style="width: 270px" v-model:value="search.bill_target_name"  placeholder="请输入关键词进行搜索"/>
      </a-form-item>
      <a-form-item label="" name='bill_type' >
        <a-select v-model:value="search.bill_type" :style="{width:'180px'}" placeholder="请选择">
          <a-select-option value="">全部报销单类型</a-select-option>
          <a-select-option :value="1">下级提交报销</a-select-option>
          <a-select-option :value="2">品牌商手动添加</a-select-option>
          <a-select-option :value="4">业务员提交</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="最近状态更新时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' rowKey='id'  :columns='columns' :data-source='data' bordered>
      <template v-slot:bill_target_name='{record}'>
        {{record.bill_target_name || '-'}}<br>
        （{{record.bill_target}}）
      </template>
      <template v-slot:content='{record}'>
        <div v-if='!record.point && !record.coupon_num && !record.exchange_num'>-</div>
        <div class="contentBox" v-else>
          <span v-if='record.point'>{{record.point}}积分<span>、</span></span>
          <span v-if='record.coupon_num'>{{record.coupon_num}}张优惠券<span>、</span></span>
          <span v-if='record.exchange_num'>{{record.exchange_num}}个礼品<span>、</span></span>
        </div>
      </template>
      <template v-slot:action="{ record }">
        <a-button type="link" v-has:reimburseMore="()=> {$router.push('/assets/reimburse/more?id='+record.id)}">查看详情</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getReimbursmentSingle } from '@/api/reimbursement';
  // 初始化默认筛选项数值
  let defSearch = {
    bill_target_name:'',
    type:1,
    start_time:'',
    end_time:'',
    bill_type:'',
    bill_status:'',
    page:1,
    limit:10
  }
  export default {
    components: { PlusOutlined },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading:false,
        data:[],
        activeKey:'',
        time:[],
        total:0,
        columns:[
        {
            title: "报销对象",
            dataIndex: "bill_target_name",
            key: "bill_target_name",
            align:'center',
            slots: { customRender: "bill_target_name" }
          },
          {
            title: "报销内容",
            dataIndex: "content",
            key: "content",
            slots: { customRender: "content" }
          },
          {
            title: "最新更新时间",
            dataIndex: "update_time",
            key: "update_time",
          },
          {
            title: "状态",
            dataIndex: "status",
            key: "status",
          },
          {
            title: "报销单类型",
            dataIndex: "bill_type",
            key: "bill_type",
          },
          {
            title: "操作",
            dataIndex: "action",
            key: "action",
            width:120,
            slots: { customRender: "action" }
          },
        ]
      });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      const tabChange = () => {
        initData(search.value);
      }
      const initData = async (values) => {
        state.listLoading = true;
        state.data = [];
          state.total = 0;
        let res = await getReimbursmentSingle({...values}).then(res => res.data).catch(error=>error);
        if (iscode(res)) {
          state.data = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        search,
        ...toRefs(state),
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,tabChange
      };
    },
  };
</script>
<style>
  .contentBox span:last-child span{display: none;}
</style>